/**
 * Alshallal HR — Shared Framer Motion variants
 *
 * Aligned with `/app/design_guidelines.json` animation_spec:
 *   - durations 140–340ms
 *   - default easing: cubic-bezier(0.22, 1, 0.36, 1) (custom "spring-out")
 *   - reduced-motion friendly (CSS layer handles it globally)
 */

// Shared spring/easing presets
export const ease = [0.22, 1, 0.36, 1];
export const easeOut = [0.16, 1, 0.3, 1];

/** Page route transition — fade + tiny rise (260ms) */
export const pageVariants = {
  initial: { opacity: 0, y: 8 },
  in:      { opacity: 1, y: 0, transition: { duration: 0.26, ease } },
  out:     { opacity: 0, y: -4, transition: { duration: 0.16, ease } },
};

/** Container that staggers its children — default 35ms cascade */
export const staggerContainer = (stagger = 0.035, delay = 0) => ({
  hidden:  { opacity: 1 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: stagger, delayChildren: delay },
  },
});

/** Each child item revealed in a staggered list */
export const staggerItem = {
  hidden:  { opacity: 0, y: 8 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.30, ease } },
};

/** Cards / tiles entrance */
export const cardEnter = {
  hidden:  { opacity: 0, y: 12, scale: 0.985 },
  visible: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.34, ease } },
};

/** Sidebar / panel slide */
export const slideInLeft = {
  hidden:  { opacity: 0, x: -16 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.30, ease } },
};
export const slideInRight = {
  hidden:  { opacity: 0, x: 16 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.30, ease } },
};

/** Subtle hover for interactive surfaces */
export const interactiveHover = {
  rest:  { scale: 1, y: 0 },
  hover: { scale: 1.02, y: -1, transition: { duration: 0.18, ease } },
  tap:   { scale: 0.98, transition: { duration: 0.10 } },
};

/** Dialog / modal pop */
export const dialogPop = {
  hidden:  { opacity: 0, scale: 0.96, y: 6 },
  visible: { opacity: 1, scale: 1, y: 0, transition: { duration: 0.22, ease } },
  exit:    { opacity: 0, scale: 0.97, y: 4, transition: { duration: 0.14, ease } },
};

/** Brand badge / chip pop */
export const popIn = {
  hidden:  { opacity: 0, scale: 0.85 },
  visible: { opacity: 1, scale: 1, transition: { duration: 0.22, ease: [0.34, 1.56, 0.64, 1] } },
};

/** Numeric counter — used for dashboard stat tiles. Pass `to={42}` from caller. */
export const counterTransition = { duration: 0.6, ease };

